import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听真实用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {item.role}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{item.content}"
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}